module.exports = __webpack_public_path__ + "img/patio-art.a841a0ac.webp";